import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { AnySignableDecision } from '@mls-wallet/shared-types';

type MockSignArg = {
  decision: AnySignableDecision;
  action: 'CONFIRM' | 'CANCEL';
  signableId: string;
};

type MockSignResponse = {
  success: boolean;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: MockSignArg }
): Promise<MockSignResponse> => {
  const { decision, action, signableId } = arg;
  return await denApi.post<MockSignResponse, MockSignArg>('mock/sign', {
    decision,
    action,
    signableId,
  });
};

export function useMockSign(
  swrOptions?: SWRMutationConfiguration<
    MockSignResponse,
    Error,
    string,
    MockSignArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    MockSignResponse,
    Error,
    string,
    MockSignArg
  >('mock/sign', fetcher, swrOptions);

  return { mockSign: trigger, isLoading: isMutating, error };
}
